﻿import HeatmapConfigurator from "./style/HeatmapConfigurator";
import HotspotConfigurator from "./style/HotspotConfigurator";
import ThematicConfigurator from "./style/ThematicConfigurator";


export default class StyleControl {
    constructor(configContainer, rootUrl, settings, type, resourcesHandler, additional) {
        this.configContainer = configContainer;
        this.rootUrl = rootUrl;
        this.settings = settings;
        this.resourcesHandler = resourcesHandler;
        this.type = type;
        this.styleOptions = null;
        this.control = null;
        this.additional = additional;
        this._init();
    }

    _init() {
        if (this.settings == null || this.settings.trim() == '') {
            this.settings = '{"Type": "' + this.type + '"}';
        }

        this.styleOptions = JSON.parse(decodeHtml(this.settings));

        switch (this.styleOptions.Type) {
            case 'HEATMAP': this.control = new HeatmapConfigurator(this.configContainer, this.rootUrl, this.styleOptions, this.resourcesHandler, this.additional);
                break;
            case 'HOTSPOT': this.control = new HotspotConfigurator(this.configContainer, this.rootUrl, this.styleOptions, this.resourcesHandler, this.additional);
                break;
            case 'TEMATIC': this.control = new ThematicConfigurator(this.configContainer, this.rootUrl, this.styleOptions, this.resourcesHandler, this.additional);
                break;
            case 'CUSTOM': {
                    if (window.CustomStyleControl) {
                        this.control = new CustomStyleControl(this.configContainer, this.rootUrl, this.styleOptions, 'CUSTOM', this.resourcesHandler, this.additional);
                    }
                } 
                break;
            default: break;
        }

        if (this.control != null) {
            this.control.init();
        }
    }

    save() {
        return this.control.save();
    }
}